import React, { useState, useEffect } from 'react';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { t } from "./../i18n";
import './ToastNotifications.css';

let notificationQueue = [];
let listeners = [];

export const addNotification = (action) => {
    const id = Date.now();
    notificationQueue = [...notificationQueue, { id, action }];
    listeners.forEach(listener => listener(notificationQueue));
    
    setTimeout(() => {
        notificationQueue = notificationQueue.filter(n => n.id !== id);
        listeners.forEach(listener => listener(notificationQueue));
    }, 2400);
};

export default function ToastNotifications({ language }) {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        listeners.push(setNotifications);
        return () => {
            listeners = listeners.filter(l => l !== setNotifications);
        };
    }, []);

    return (
        <>
            {notifications.map((notification, index) => {
                const reverseIndex = notifications.length - 1 - index;
                const bottomPosition = 20 + (reverseIndex * 55);
                
                return (
                    <div 
                        key={notification.id}
                        className={`accept-toast ${notification.action === "cancel" ? "cancel-toast" : ""}`}
                        style={{ 
                            position: 'fixed',
                            bottom: `${bottomPosition}px`,
                            right: '20px',
                            zIndex: 99999,
                            transition: 'bottom 0.3s ease-out'
                        }}
                    >
                        {notification.action === "Accepted" ? (
                            <>
                                <EventAvailableIcon className="accept-toast-icon" />
                                <span>{t("common.acceptedSuccess", language)}</span>
                            </>
                        ) : (
                            <>
                                <DoDisturbIcon className="cancel-toast-icon" />
                                <span>{t("common.cancelledSuccess", language)}</span>
                            </>
                        )}
                    </div>
                );
            })}
        </>
    );
}
